import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
// import { HashLink } from 'react-router-hash-link'
import useMediaQuery from '@mui/material/useMediaQuery'
import data from '../../data'

export default function NotificationBanner () {
  const smallScreen = !useMediaQuery('(min-width:600px)')

  return (
    <Box
      className="creme"
      sx={{
        textAlign: 'center',
        zIndex: 3,
        display: 'block',
        position: 'relative',
        borderColor: 'primary.light',
        boxShadow: 2
      }} p={1}
    >
      {
        smallScreen
          ? (<Typography variant="body2">Try The Black Dog: Schedule a free <Link href={data.calendar.bookingUrl} target="_blank">Introduction Class.</Link>.</Typography>)
          : (<Typography variant="body2">Try The Black Dog: Schedule a free <Link href={data.calendar.bookingUrl} target="_blank">Introduction Class</Link>.</Typography>)
      }
    </Box>
  )
}
